import type { ComponentProps, ReactNode } from 'react'
import useMeasure from 'react-use-measure'
import { motion } from 'motion/react'

export const ResizablePanel = ({
	children,
	...props
}: ComponentProps<typeof motion.div> & {
	children: ReactNode
}) => {
	const [ref, { height }] = useMeasure()

	return (
		<motion.div
			animate={{ height }}
			{...props}
		>
			<div ref={ref}>{children}</div>
		</motion.div>
	)
}
